module.exports = __webpack_public_path__ + "img/mobildev-logo.5795c79a.svg";